import React from 'react'
import SectionCollapse from '../../../../../section/SectionCollapse'
import TextValue from '../../../../../text/TextValue'
import BasicInformation from './BasicInformation'
import UsersInformation from './UsersInformation'
import UnitsOfLearning from './UnitsOfLearning'
import TextNotAssigned from '../../../../../text/TextNotAssigned'

const ClassInfo = ({ detail = {} }) => {
  return (
    <>
      <TextValue title='Curriculum' value={detail?.curriculum || <TextNotAssigned />} />
      <div className='py-2'/>
      <SectionCollapse title='Basic Information'>
        <BasicInformation detail={detail} />
      </SectionCollapse>
      <UsersInformation type='Teachers' items={detail.teachers} />
      <UsersInformation type='Students' items={detail.students} />
      { detail.curriculum &&
        <UnitsOfLearning items={detail.unitsOfLearning || []} />
      }
    </>
  )
}

export default ClassInfo